// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <g transform="translate(2 3)">
    <path d="M18.5,0h-17C0.7,0,0,0.7,0,1.5v15C0,17.3,0.7,18,1.5,18h17c0.8,0,1.5-0.7,1.5-1.5v-15C20,0.7,19.3,0,18.5,0z M19,16.5
      c0,0.3-0.2,0.5-0.5,0.5h-17C1.2,17,1,16.8,1,16.5V5h18V16.5z M19,4H1V1.5C1,1.2,1.2,1,1.5,1h17C18.8,1,19,1.2,19,1.5V4z" />
    <rect x="10" y="13" width="5" height="1" />
    <polygon points="10,11.1 4.9,14.8 4.9,13.5 8.3,11.1 4.9,8.6 4.9,7.4" />
    <line class="st0" x1="8.3" y1="11.1" x2="4.9" y2="13.5" />
    <line class="st0" x1="8.3" y1="11.1" x2="4.9" y2="8.6" />
  </g>
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-software-Bvhe0OD1.js.map
